import { render, staticRenderFns } from "./billet-doux-greeting-card.vue?vue&type=template&id=24ae3fd0&scoped=true"
import script from "./billet-doux-greeting-card.vue?vue&type=script&lang=js"
export * from "./billet-doux-greeting-card.vue?vue&type=script&lang=js"
import style0 from "./billet-doux-greeting-card.vue?vue&type=style&index=0&id=24ae3fd0&prod&lang=scss&scoped=true"
import style1 from "./billet-doux-greeting-card.vue?vue&type=style&index=1&id=24ae3fd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ae3fd0",
  null
  
)

export default component.exports